import { Component, input, OnDestroy, OnInit } from '@angular/core';
import { SourceEnum } from '../../../../../../../shared/store/typeahead/types';
import { LeadService } from '../../../../../../../shared/store/lead/lead.service';
import { Observable } from 'rxjs';
import { LeadPrincipalCandidateListItemModel } from '../../../../../../../shared/store/lead/types';
import { GenericApiCall } from '../../../../../../../common/store/types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SubHeaderService } from '../../../../../../../shared/store/subheader/subheader.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filterTrue } from '../../../../../../../shared/pipe/rxjs/operators';
import {
  ModalComponent,
  ModalComponentKey,
} from '../../../../../../../shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.LeadSetAsDuplicatesContentComponent)
@Component({
  selector: 'app-lead-set-as-duplicates-content',
  standalone: false,
  templateUrl: './lead-set-as-duplicates-content.component.html',
  styleUrl: './lead-set-as-duplicates-content.component.scss',
})
export class LeadSetAsDuplicatesContentComponent implements OnInit, OnDestroy {
  readonly modalRandomIdentifier = input.required<number>();
  readonly source = input<SourceEnum>(SourceEnum.Component);
  readonly leadUniqueId = input.required<string>();

  apiCall: GenericApiCall<any, any>;
  rowData: LeadPrincipalCandidateListItemModel;
  principalCandidates$: Observable<LeadPrincipalCandidateListItemModel[]>;
  markAsDuplicateResult$: Observable<boolean>;

  constructor(
    private readonly leadService: LeadService,
    private readonly subHeaderService: SubHeaderService,
    private readonly activeModalService: NgbActiveModal,
  ) {
    this.principalCandidates$ = this.leadService.getPrincipalCandidates.value$;
    this.markAsDuplicateResult$ = this.leadService.markAsDuplicate.value$;
  }

  ngOnInit(): void {
    this.apiCall = this.leadService.getPrincipalCandidates;
    this.leadService.getPrincipalCandidates.call(this.leadUniqueId());

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'leadMarkAsDuplicate') {
          this.onMarkAsDuplicate();
        }
        this.subHeaderService.setTriggerAction('');
      });

    // One subscription for the modal's lifetime, not one per click: a failed call never emits
    // true, so a per-click take(1) would stay pending and fire again on the next success.
    this.markAsDuplicateResult$
      .pipe(filterTrue(), untilDestroyed(this))
      .subscribe(() => {
        this.leadService.markAsDuplicate.reset();
        this.activeModalService.close();
      });
  }

  ngOnDestroy(): void {
    // The next opening (possibly on another lead) must not show these candidates while it loads.
    this.leadService.getPrincipalCandidates.reset();
  }

  onGetRowData() {
    //copy the data
    const result = this.rowData;

    //when we get the data, reset the data
    this.onSetRowData(undefined);

    //return the copy of the data
    return result;
  }

  onSetRowData(rowData: any) {
    this.rowData = rowData;
  }

  private onMarkAsDuplicate() {
    const principalCandidateListItemModel: LeadPrincipalCandidateListItemModel =
      this.onGetRowData();
    if (!principalCandidateListItemModel) return;

    this.leadService.markAsDuplicate.call({
      leadUniqueId: this.leadUniqueId(),
      parentLeadUniqueId: principalCandidateListItemModel.uniqueId,
    });
  }
}
